const ShimmerMenu = () => {
    return (
      <div className="mx-56">
        <div className=" flex mt-10 gap-2 mx-auto justify-center ">
          <div className="w-2/3">
            <h1 className="m-2 w-9/12 h-6 bg-gray-200 rounded-lg"></h1>
            <p className="m-2 w-6/12 h-6 bg-gray-200 rounded-lg"></p>
            <p className="m-2 w-7/12 h-6 bg-gray-200 rounded-lg"></p>
            <p className="m-2 w-6/12 h-6 bg-gray-200 rounded-lg"></p>
            <p className="m-2 w-5/12 h-6 bg-gray-200 rounded-lg"></p>
            <p className="m-2 w-5/12 h-6 bg-gray-200 rounded-lg"></p>
          </div>
          <div className="rounded-lg h-36 w-36 bg-gray-200"></div>
        </div>
  
        <div className="w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"></div>
        <div className="w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"></div>
        <div className="w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"></div>
        <div className="w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"></div>
        <div className="w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"></div>
        <div className="w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"></div>
        <div className="w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"></div>
      </div>
    );
  };
  
  export default ShimmerMenu;
  